<template>
  <q-dialog
    ref="dialog"
    @hide="onDialogHide"
    persistent
  >
    <q-card class="q-dialog-plugin text-center q-pa-lg">
      <q-icon
        name="error_outline"
        color="negative"
        style="font-size: 4rem;"
      />
      <h1 class="text-h5 text-uppercase q-py-sm">
        <p class="q-mb-sm">
          {{ $t('titles.sorry') }}
        </p>
        <p class="text-negative q-mb-sm">
          {{ $t('titles.lost_connection') }}
        </p>
        <p class="q-px-lg">
          {{ $t('titles.cta') }}
        </p>
      </h1>
      <!-- <q-btn
        @click="onRefresh"
        round
        color="white"
        text-color="primary"
        icon="refresh"
        class="shadow-2"
      /> -->
    </q-card>
  </q-dialog>
</template>
<script>
export default {
  props: {},
  methods: {
    onRefresh() {
      window.location.reload(true);
    },
    show() {
      this.$refs.dialog.show();
    },
    hide() {
      this.$refs.dialog.hide();
    },
    onDialogHide() {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$emit('hide');
    },

    onOKClick() {
      // on OK, it is REQUIRED to
      // emit "ok" event (with optional payload)
      // before hiding the QDialog
      this.$emit('ok');
      // or with payload: this.$emit('ok', { ... })

      // then hiding dialog
      this.hide();
    },
    onCancelClick() {
      // we just need to hide dialog
      this.hide();
    },
  },
};
</script>
<i18n>
{
  "en": {
    "titles": {
      "sorry": "Sorry...",
      "lost_connection": "You have lost connection to our servers...",
      "cta": "We recommend reloading the Diamond Duels App to reconnect"
    }
  }
}
</i18n>
